import { observer } from 'mobx-react';
import classNames from 'classnames';

import styles from './Status.module.scss';

import { PriceStatus } from 'chaika-enums';

import { PriceStatusDic } from '@store/models/Price';
import { translate } from '@chaika/i18n/helper';

interface Props {
    value: PriceStatus;
    dataTest: string;
}

export const Status = observer(({ value }: Props) => {
    return (
        <div className={styles.root}>
            <div className={styles.title}>{translate('status')}</div>
            <div className={styles.text}>
                <div className={classNames([styles.icon, styles[value]])}></div>
                {PriceStatusDic[value]()}
            </div>
        </div>
    );
});
